import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=66d735a5&scoped=true&"
import script from "./AppAvatar.vue?vue&type=script&lang=js&"
export * from "./AppAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=66d735a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d735a5",
  null
  
)

export default component.exports